/**
 * @file pages/Wishlist.jsx
 * @description Wishlist page. Displays tours the user has favorited,
 * with the ability to remove items from the wishlist.
 */

import React, { useContext } from 'react';
import { WishlistContext } from '../Context/WishlistContext';
import Header from "../Components/Layouts/Header";

const Wishlist = () => {
  const { wishlist, removeFromWishlist } = useContext(WishlistContext);

  return (
    <>
      <Header />

      <div className="p-4 sm:p-6 md:p-10 pt-28">
        <h1 className="text-3xl font-bold text-center mb-8 text-[#243185]">Your Wishlist</h1>

        {wishlist.length === 0 ? (
          <p className="text-center text-gray-600">No items in wishlist.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {wishlist && wishlist.length > 0 && wishlist.map((item, index) => (
              <div
                key={index}
                className="flex flex-col border rounded-xl overflow-hidden shadow-md bg-white hover:shadow-lg transition-all"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-[300px] w-full object-cover"
                />
                <div className="flex flex-col p-4 flex-1 justify-between">
                  <h2 className="text-lg font-semibold mb-2">{item.title}</h2>
                  <p className="text-gray-700 font-medium mb-4">₹{item.price}</p>
                  <button
                    onClick={() => removeFromWishlist(item.title)}
                    className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Wishlist;

